import React, { useState } from 'react'
import { Box, Button, Container, Grid, Typography, } from '@mui/material';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import client from "../../images/Client1.png";
import client2 from "../../images/Client2.png";
import client3 from "../../images/Client3.png";
import client4 from "../../images/Client4.png";
import client5 from "../../images/Client5.png";
import client6 from "../../images/Client6.png";
import { Input } from '@mui/material';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL, APP_URL } from '../../Config';
import swal from 'sweetalert';


const Footer = () => {
  const [Email,SetEmail] = useState();

  const Subscribe = async()=>{
  if(Email){
 
     await axios
      .get(`${API_URL}/subscribe.php?mail=${Email}`,{
        headers: {
          "Content-Type": "application/json",
        },
      }).then((res)=>{
          if(res.data.code ==200){
            swal({ 
              title: "Success", 
              text: `${res.data.message}`,
              icon: "success" ,
              allowOutsideClick: false,
              confirmButtonText: 'ok',
              confirmButtonColor: '#2dbe60',})
          }else{
            swal({ 
              title: "Warning", 
              text: `${res.data.message}`,
              icon: "error" ,
              allowOutsideClick: false,
              confirmButtonText: 'ok',
              confirmButtonColor: '#2dbe60',})
          }
      }).catch((error)=>{
          console.log(error);
      })
  }else{
    console.log('No mail');
  }
 
  }

  return (
    <>
      <Box className='footer_start' sx={{ backgroundColor: '#000000' }} color='#fff'>

        <Container maxWidth='xl'>
          <Grid container spacing={2} padding={3}>
            <Grid item lg={2} sm={4} md={4} xs={6}>
              <img className='logos_client' src={client} width='100%' />
            </Grid>
            <Grid item lg={2} sm={4} md={4} xs={6}>
              <img className='logos_client' src={client2} width='100%' />
            </Grid>
            <Grid item lg={2} sm={4} md={4} xs={6}>
              <img className='logos_client' src={client3} width='100%' />
            </Grid>
            <Grid item lg={2} sm={4} md={4} xs={6}>
              <img className='logos_client' src={client4} width='100%' />
            </Grid>
            <Grid item lg={2} sm={4} md={4} xs={6}>
              <img className='logos_client' src={client5} width='100%' />
            </Grid>
            <Grid item lg={2} sm={4} md={4} xs={6}>
              <img className='logos_client' src={client6} width='100%' />
            </Grid>
          </Grid>
        </Container>

        <Box className='arrow'>
        </Box>

        <Container maxWidth='xl' className='trading_view'>
          <Grid container spacing={2}>
            <Grid item lg={3} sm={4} md={3} xs={12}>
              <Box>
                <Typography variant='h5'>  Our Address  </Typography>
                <Typography variant='h6'>  4 Grand Central Terminal New York,  NY 10 City name, CA 90896 USA. contact@example.com
                </Typography>
                <Box className='social_link'>
                  <FacebookIcon /> <LinkedInIcon />  <InstagramIcon /> <TwitterIcon />
                </Box>
              </Box>
            </Grid>
            <Grid item lg={3} sm={4} md={3} xs={12}>
              <Typography variant='h5'>
                Useful Links
              </Typography>
              <ul>
                <li> <Link to={''}> <KeyboardDoubleArrowRightIcon />  Collectibles </Link> </li>
                <li>  <Link to={''}>  <KeyboardDoubleArrowRightIcon />   Photography  </Link> </li>
                <li>  <Link to={''}>  <KeyboardDoubleArrowRightIcon />   Trading Cards  </Link></li>
                <li>  <Link to={''}> <KeyboardDoubleArrowRightIcon />  Virtual Worlds  </Link></li>
              </ul>
            </Grid>
            <Grid item lg={3} sm={4} md={3} xs={12}>
              <Typography variant='h5'>
                Our Policy
              </Typography>
              <ul>
                <li>  <Link to={''}>  <KeyboardDoubleArrowRightIcon /> Help Center  </Link></li>
                <li>  <Link to={''}>  <KeyboardDoubleArrowRightIcon />  My Collections  </Link></li>
                <li>  <Link to={''}>  <KeyboardDoubleArrowRightIcon />   Platform Status </Link> </li>
                <li>  <Link to={''}>  <KeyboardDoubleArrowRightIcon />   Newsletter  </Link> </li>
              </ul>
            </Grid>
            <Grid item lg={3} sm={12} md={3} xs={12}>
              <Typography variant='h5'>
                Stay Informed By Newsletter
              </Typography>
              <Typography variant='' component='div'>
                *Subscribe to our newsletter to receive early discount offers and updates.
              </Typography>
              <Box sx={{marginY:'1rem'}}> 
                <Input placeholder=""  onChange={(e)=>{SetEmail(e.target.value)}} type="email" variant="outlined" color="primary" />
                <Button variant='containt' onClick={()=>Subscribe()}>Subscribe</Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box className='foot_bottom' textAlign='center' paddingY={1} color='#fff' sx={{ backgroundColor: '#000000' }} >
        Copyright by <span fontWeight='bold' style={{ color: '#d374ffed' }}> Enefti </span> All Rights Reserved.</Box>
    </>
  )
}

export default Footer;